import { Component } from '@angular/core';
import { AppHeader } from '../../components/header/header';

@Component({
  selector: 'app-contact-page',
  standalone: true,
  imports: [AppHeader],
  templateUrl: './contact-page.html',
  styleUrl: './contact-page.scss'
})
export class ContactPage {

}
